module.exports = __webpack_public_path__ + "img/cx_teste_dengue_anticorpos.27224142.webp";